import dashboard from './dashboard';
import user_management from './user-management';
import administration from './administration';
import products from './products';
import community from './community';
import appContent from './app-content';
import lookingForProducts from './looking-for-products';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, administration, user_management, products, lookingForProducts, community, appContent]
};

export default menuItems;
